'use client';

import CardModal from '../molecules/cardModal';
import ShibHorizDivider from '../atoms/shibHorizDivider';
import { useContext, useEffect } from 'react';
import { ModalContext } from '../../contexts/modal-provider';
import { LandPurchaseContext } from '../../contexts/land-purchase-context';
import { AggregateLandService, LandTiers } from '../../services/AggregateLand/AggregateLandService';
import { useAccount } from 'wagmi';

const PurchaseSummaryModal = () => {
    const { openModal, closeModal } = useContext(ModalContext);
    const { landQuantity, totalEth, purchaseSummary, landType } =
        useContext(LandPurchaseContext);
    const { address } = useAccount()
    const handlePayNow = () => {
        closeModal();
        openModal({ type: 'GUARDARIAN_PAYMENT_MODAL' });
    };
    useEffect(() => {
        if (address) {
            const sendRequest = async () => {
                const lands = await AggregateLandService.fetchAggregateLands(
                    landType as LandTiers,
                    landQuantity
                );
            };
            sendRequest();
        }
    }, [totalEth]);

    return (
        <CardModal id="purchase-summary-modal">
            <div className="text-left">
                <h3 className="text-2xl font-normal leading-loose text-orange-600">Purchase Summary</h3>
                <p className="text-xs">
                    You are about to purchase Metaverse Land using a credit or debit card
                </p>
                <ShibHorizDivider className="my-6" />
                <div className="inline-flex w-full items-center justify-between">
                    <div className="flex-col gap-2">
                        <div className="text-sm font-normal leading-tight text-white">Land Price (USD):* </div>
                        <span className="text-xs">
                            {landQuantity} {landQuantity > 1 ? 'Parcels' : 'Parcel'}
                        </span>
                    </div>
                    <div className="text-base font-semibold leading-normal text-neutral-50">
                        {purchaseSummary.price_amount
                            ? '$' + purchaseSummary?.price_amount?.toFixed(2)
                            : 'Loading...'}
                    </div>
                </div>
                <ShibHorizDivider className="my-6" />
            </div>
            <div className="mt-6 flex flex-col gap-4 text-center">
                <p className="m-auto w-3/4 text-sm">
                    * Land pricing is dynamic and dependent on ETH price at the time of purchase. Gas and
                    processing fees (3% of land price) will be added to the land price on the payment screen.
                </p>
                <button
                    disabled={!purchaseSummary.price_amount}
                    onClick={handlePayNow}
                    className="m-auto flex h-12 w-full items-center justify-center gap-2 rounded-3xl bg-[#F38F2E] px-8 text-sm font-semibold text-white"
                >
                    Pay with Credit Card
                    <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2.375 6.99243H18.625M2.375 7.61743H18.625M4.875 11.9924H9.875M4.875 13.8674H7.375M4.25 16.3674H16.75C17.7855 16.3674 18.625 15.528 18.625 14.4924V5.74243C18.625 4.7069 17.7855 3.86743 16.75 3.86743H4.25C3.21447 3.86743 2.375 4.7069 2.375 5.74243V14.4924C2.375 15.528 3.21447 16.3674 4.25 16.3674Z"
                            stroke="#FAFAFA"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
                <p className="text-xs">Failed transaction gas fees cannot be refunded</p>
                {/* <Link
          href={'https://google.com'}
          className="text-blue-500 text-sm font-semibold leading-tight"
        >
          Read full Terms and Conditions
        </Link> */}
            </div>
        </CardModal>
    );
};

export default PurchaseSummaryModal;
